import { createAction } from '@reduxjs/toolkit';

export const CLEAR_STACK_ACTION_TYPE = 'saga/clearStack';
export const clearStackAction = createAction(CLEAR_STACK_ACTION_TYPE);
